import FontFaceObserver from 'fontfaceobserver';

export default () => {
	const $html = document.getElementsByTagName('html')[0];
	const heading = new FontFaceObserver('span');
	const body = new FontFaceObserver('aktiv-grotesk');

	Promise.all([heading.load(), body.load()])
		.then(() => $html.classList.add('fonts-loaded'))
		.catch(() => $html.classList.add('fonts-failed'));
};
